import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const cases = [
  {
    path: '/vector/cases',
    name: 'vector-cases-home',
    component: () => import('@/pages/vector/cases/CasesListPage.vue'),
    meta: {
      title: 'Cases',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/cases/:case_id',
    name: 'vector-cases-case-details',
    component: () => import('@/pages/vector/cases/CaseDetailPage.vue'),
    meta: {
      title: 'Case Details',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/cases/new/manual',
    name: 'vector-cases-create-manual',
    component: () => import('@/pages/vector/cases/manualCreate.vue'),
    meta: {
      title: 'Create A Case',
      resource: 'Vector',
      action: 'create',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/cases/new/upload',
    name: 'vector-cases-create-upload',
    component: () => import('@/pages/vector/cases/uploadCreate.vue'),
    meta: {
      title: 'Create Cases',
      resource: 'Vector',
      action: 'create',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
]

export default cases
